const configured = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000/api";

/**
 * When this page is opened from another device (a phone on the same Wi-Fi) while the API address is configured as localhost, "localhost" would be the
 * phone itself — so the API is reached on the same machine that served this page instead. Has no effect on a real deployment.
 */
function reachable(url: string): string {
  try {
    const u = new URL(url);
    const local = ["localhost", "127.0.0.1"];
    if (local.includes(u.hostname) && !local.includes(window.location.hostname)) {
      u.hostname = window.location.hostname;
      return u.toString().replace(/\/$/, "");
    }
  } catch {
    /* not a URL — use it as it is */
  }
  return url;
}

export const BASE_URL = reachable(configured);
